import {Form,   Modal,  Row, Col,    } from 'antd'
import React, { useEffect } from 'react'
import classes from './expenseInvoice.module.css'
import {  useFypdjUpdateQuery } from '../../store/DianShangYeWuApi';
import ExpenseListWithId from '../../document/expense/ExpenseListWithId'
import Asterisk from '../../cpn/Asterisk'   
import FilePreview from '../../cpn/FilePreview'
function ExpenseInvoiceCheck(props) {
    const [open,setOpen] = React.useState(false);
    const [info,setInfo] = React.useState({
        'fypdj_qy_id': '',
        'fypdj_qy_name': '',
        'fypdj_uid': '',
        'fypdj_uname': '',
        'fypdj_kh_id': '',
        'fypdj_kh_name': '',
        'fypdj_state': '',
        'fypdj_image_file': '',
        'fypdj_image_name': '',
        'fypdj_id': '',
        'fypdj_amount': '',
        'fypdj_content': '',
        'fypdj_bm_id': '',
        'fypdj_bm_name': '',
        'fypdj_ddzc_id': ''
    })
    const {data, isSuccess} = useFypdjUpdateQuery({fypdj_id:props.fypdj_id},{skip:!open,refetchOnMountOrArgChange:1});
    const [form] = Form.useForm();
    
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            setInfo({
                'fypdj_qy_id': data.Result.fypdj_qy_id, 
                'fypdj_qy_name': data.Result.fypdj_qy_name,
                'fypdj_uid': data.Result.fypdj_uid,
                'fypdj_uname': data.Result.fypdj_uname,
                'fypdj_ctime': data.Result.fypdj_ctime,
                'fypdj_kh_id': data.Result.fypdj_kh_id,
                'fypdj_kh_name': data.Result.fypdj_kh_name,
                'fypdj_state': data.Result.fypdj_state,
                'fypdj_image_file': data.Result.fypdj_image_file,
                'fypdj_image_name': data.Result.fypdj_image_name,
                'fypdj_id': data.Result.fypdj_id,
                'fypdj_amount': data.Result.fypdj_amount,
                'fypdj_content': data.Result.fypdj_content,
                'fypdj_bm_id': data.Result.fypdj_bm_id,
                'fypdj_bm_name': data.Result.fypdj_bm_name,
                'fypdj_ddzc_id': data.Result.fypdj_ddzc_id
            });          
        }
        
    }, [data, isSuccess,form])    

    const formatCurrency = (value) => {
        if (value === null || value === undefined) return '0.00';
        return `￥${Number(value).toLocaleString('zh-CN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    }
     return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.fypdj_kh_name}</a>
            <Modal
                open={open} 
                onCancel={() => {setOpen(false)}}
                width={1330}
                form={form}
                footer={null}
            >
                <Form
                    form={form}
                    className={classes.form}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                >
                    <Row style={{width:"1280px"}}>
                        <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #3366FF',borderLeft:'3px solid #3366FF'}}></Col>
                        <Col span={16} className={classes.row_top_middle} style={{color:'#3366FF',borderTop:'3px solid #3366FF'}}>费用票登记</Col>
                        <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #3366FF',borderRight:'3px solid #3366FF'}}></Col>
                         {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #3366FF',color:'#3366FF'}}><Asterisk color='red'/> 费用单号</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            <ExpenseListWithId
                                id={info.fypdj_ddzc_id}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                            />
                        </Col>  
                        <Col span={2} className={classes.col_top_label} ><Asterisk color='red'/> 费用票金额</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            {formatCurrency(info.fypdj_amount)}
                            
                        </Col>  
                        <Col span={2}  className={classes.col_top_label} ><Asterisk color='red'/> 部门</Col>
                        <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #3366FF'}}>
                            {info.fypdj_bm_name}
                        </Col> 
                        {/* 第二行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #3366FF'}}><Asterisk color='red'/> 客户</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            {info.fypdj_kh_name}
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 上传费用票</Col>
                        <Col span={14}  className={classes.col_middle_input} style={{borderRight:'3px solid #3366FF'}}>
                            <FilePreview
                                fileNames={info.fypdj_image_file}
                                fileUrls={info.fypdj_image_name}
                            />
                        </Col>
                        {/* 第三行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #3366FF',borderBottom:'3px solid #3366FF'}}> 备注</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderBottom:'3px solid #3366FF'}}>
                            {info.fypdj_content}
                        </Col>
                        <Col span={2}  className={classes.col_middle_label} style={{borderBottom:'3px solid #3366FF'}}>提交记录</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderBottom:'3px solid #3366FF'}}>{info.fypdj_uname} {info.fypdj_ctime}</Col> 
                        <Col span={2} className={classes.col_middle_label} style={{borderBottom:'3px solid #3366FF'}}>编号</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:'3px solid #3366FF',borderBottom:'3px solid #3366FF'}}>
                            {info.fypdj_id}
                        </Col>    
                                                               
                    </Row>                       
                </Form>
            </Modal>

        </>
    )
}

export default ExpenseInvoiceCheck